var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgCloseCircle(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.00016 1.33398C4.3135 1.33398 1.3335 4.31398 1.3335 8.00065C1.3335 11.6873 4.3135 14.6673 8.00016 14.6673C11.6868 14.6673 14.6668 11.6873 14.6668 8.00065C14.6668 4.31398 11.6868 1.33398 8.00016 1.33398ZM9.72683 5.33398L8.00016 7.06065L6.2735 5.33398L5.3335 6.27398L7.06016 8.00065L5.3335 9.72732L6.2735 10.6673L8.00016 8.94065L9.72683 10.6673L10.6668 9.72732L8.94016 8.00065L10.6668 6.27398L9.72683 5.33398ZM2.66681 8.00056C2.66681 10.9406 5.06014 13.3339 8.00014 13.3339C10.9401 13.3339 13.3335 10.9406 13.3335 8.00056C13.3335 5.06056 10.9401 2.66722 8.00014 2.66722C5.06014 2.66722 2.66681 5.06056 2.66681 8.00056Z",
    fill: "#3A5C8E"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCloseCircle);
export default __webpack_public_path__ + "static/media/close-circle.2ee5073c.svg";
export { ForwardRef as ReactComponent };